import React, { useState, useEffect, useCallback, useRef } from 'react';
import Popup from 'reactjs-popup';
import EmailItem from './EmailItem';
import { AgGridReact } from 'ag-grid-react';
import Loader from '../Loader';

import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const EmailList = () => {
    const gridRef = useRef();
    const [rowData, setRowData] = useState();
    const [pageLoading, setPageLoading] = useState(false);

    const gridCellRenderer = (params) => {
        if (params.value) {
            let _value = '<span title="' + params.value + '">' + params.value + '</span>';
            /* return <div dangerouslySetInnerHTML={{ __html: _value }}></div>;*/
            return <Popup trigger={<div dangerouslySetInnerHTML={{ __html: _value }}></div>} modal>{close => (<EmailItem data={params.data} onClose={() => { close(); }}></EmailItem>)}</Popup>;
        }
    }

    const statusCellRenderer = (params) => {
        if (params.value) {
            let statue = params.data.deliveryStatus == 1 ? "Email Sent" : "Pending";
            let _value = '<span title="' + statue + '">' + statue + '</span>';
            return <Popup trigger={<div dangerouslySetInnerHTML={{ __html: _value }}></div>} modal>{close => (<EmailItem data={params.data} onClose={() => { close(); }}></EmailItem>)}</Popup>;
        }
    }

    const columnDefs = [
        { headerName: 'Application', field: 'application', filter: true, width: 150, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Title', field: 'title', filter: true, width: 290, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Send Date', field: 'created', suppressSizeToFit: true, filter: false, width: 150, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'To', field: 'to', filter: true, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Body', colId: 'email-body', field: 'bodyOfEmail', filter: false, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Status', field: 'deliveryStatus', width: 100, suppressSizeToFit: true, sortable: false, cellRenderer: p => statusCellRenderer(p), resizable: true },
    ];

    const cellClickedListener = useCallback(event => {
        if (event.colDef.field === 'edit-button') {
            alert("You want to edit: " + event.data.id);
        }
        else if (event.colDef.field === 'delete-button') {
            alert("You want to delete: " + event.data.id);
        }
    }, []);


    useEffect(() => {
        setPageLoading(true);
        fetch('/api/UmEmail/filteredemails')
            .then(result => result.json())
            .then(rowData => {
                setRowData(rowData.data);
                gridRef.current.api.sizeColumnsToFit();
                setPageLoading(false);
            })        
    }, []);

    const gridOptions = {
        columnDefs: columnDefs,
        pagination: true,
        rowSelection: 'single',
        enableFilter: true,
        cacheBlockSize: 25,
        paginationPageSize: 25,
        getRowHeight: (params) => 25
    }

    return (
        <div className="card">
            <h5 className="card-header py-3">
                <i className="fa fa-folder-open-o" aria-hidden="true"></i> UM Emails
            </h5>
            <div className="card-body" style={{ height: "75vh" }}>
                {pageLoading && <Loader />}

                <div className="ag-theme-alpine" style={{ height: "100%" }}>
                    <AgGridReact ref={gridRef} onCellClicked={cellClickedListener} rowData={rowData} gridOptions={gridOptions} />
                </div>                
            </div>
        </div>
    );
};

export default EmailList;